export class Logger {
  private isMute = false;
  private infoHead = '[AppLauncher]';
  private headStyle = ['color: rgb(42, 83, 205)', 'font-weight: 900'].join(';');

  public constructor(name?: string) {
    if (name) {
      this.infoHead = `[${name}]`;
    }
  }

  public log(...args: unknown[]): void {
    if (this.isMute) {
      return;
    }
    console.info(`%c${this.infoHead} %c${args[0]}`, this.headStyle, 'font-weight: bold', ...args.slice(1));
  }

  public logKV(key: string, value: unknown): void {
    if (this.isMute) {
      return;
    }
    console.info(`%c${this.infoHead} %c${key}:`, this.headStyle, 'color: #45af7e; font-weight: bold', value);
  }

  public mute(): void {
    this.isMute = true;
  }

  public unmute(): void {
    this.isMute = false;
  }
}
